module.exports = __webpack_public_path__ + "img/img_level_2.287d9d1b.png";